import { useEffect } from 'react';
import {
    Button,
    TextField,
    IndexTable,
    useIndexResourceState,
} from '@shopify/polaris';
import '../index.css';
import Language from '../../../../i18n/Language';
const t = Language;

const IndexTableBox = (props) => {
    // 通信数据
    const { 
        tabKey, 
        loading, 
        checkState, 
        dataList, 
        obj_name, 
        headings, 
        setChangeInputVal, 
        onBlurUpdateSeo, 
        updateTableIgnore, 
        deleteBrokenLink,
        getTableItemState,
        promotedBulkActions,
        domain,
    } = props;

    // 源文案
    const resourceName = {
        singular: 'dataList',
        plural: `${t(obj_name)}`,
    }
    const selectableOrders = dataList.filter((item) => !item.disabled);
    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(selectableOrders);

    // 操作输入框
    const handleChangeVal = (val, obj) => {
        setChangeInputVal(val, obj);
    };

    // 阻止冒泡
    const stopActionDeep = (e) => {
        e.stopPropagation();
    }

    // 保存链接
    const onBlurSaveLink = (obj) => {
        onBlurUpdateSeo(obj);
    }

    // 列表内容
    const TableDataList = dataList.map((item, index) => {
        return tabKey === 0 ? <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading || item.disabled || (checkState && tabKey === 0)}
        >
            <IndexTable.Cell>
                <div className='table_text' onClick={stopActionDeep}><Button variant='plain' textAlign="left" onClick={() => {
                    window.open(`https://${domain}${item.fr_link}`)
                }}>{item.fr_link}</Button></div>
            </IndexTable.Cell>
            <IndexTable.Cell>{Boolean(item.traffic) ? item.traffic : 0}</IndexTable.Cell>
            <IndexTable.Cell>{item.fr_time}</IndexTable.Cell>
            <IndexTable.Cell>
                <div onClick={stopActionDeep} className='textfile_input'>
                    <TextField
                        id={`targetVal-${item.id}`}
                        value={item.to_link || ""}
                        onChange={(val) => handleChangeVal(val, item)}
                        placeholder='e.g. /shop/shoes "/" for homepage'
                        disabled={item.disabled}
                        error={item.errorTip}
                    />
                </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
                <div onClick={stopActionDeep} className='flex_layout'>
                    <Button 
                        disabled={item.disabled || !item.saveState || !Boolean(item.to_link)} 
                        // outline={item.disabled || !item.saveState || !Boolean(item.to_link)}
                        // primary={item.saveState && Boolean(item.to_link)} 
                        loading={item.saveBtnLoading}
                        onClick={() => onBlurSaveLink(item)}
                    >{t("Save")}</Button>
                    <Button 
                        disabled={item.disabled}
                        loading={item.ignoreBtnLoading}
                        onClick={() => updateTableIgnore(item, 'ignore')}
                    >{t("Ignore")}</Button>
                </div>
            </IndexTable.Cell>
        </IndexTable.Row> : 
        tabKey === 1 ? <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading || item.disabled}
        >
            <IndexTable.Cell>
                <div className='table_text' onClick={stopActionDeep}><Button variant='plain' textAlign="left" onClick={() => {
                    window.open(`https://${domain}${item.fr_link}`)
                }}>{item.fr_link}</Button></div>
            </IndexTable.Cell>
            <IndexTable.Cell>{Boolean(item.traffic) ? item.traffic : 0}</IndexTable.Cell>
            <IndexTable.Cell>
                <div onClick={stopActionDeep} className='textfile_input'>
                    <TextField
                        id={`targetVal-${item.id}`}
                        value={item.to_link || ""}
                        onChange={(val) => handleChangeVal(val, item)}
                        placeholder='e.g. /shop/shoes "/" for homepage'
                        disabled={item.disabled}
                        error={item.errorTip}
                    />
                </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
                <div onClick={stopActionDeep} className='flex_layout'>
                    <Button 
                        disabled={item.disabled || !item.saveState || !Boolean(item.to_link)} 
                        // outline={item.disabled || !item.saveState || !Boolean(item.to_link)}
                        // primary={item.saveState && Boolean(item.to_link)} 
                        loading={item.saveBtnLoading}
                        onClick={() => onBlurSaveLink(item)}
                    >{t("Save")}</Button>
                    <Button 
                        disabled={item.disabled}
                        loading={item.ignoreBtnLoading}
                        onClick={() => updateTableIgnore(item, 'ignore')}
                    >{t("Ignore")}</Button>
                </div>
            </IndexTable.Cell>
        </IndexTable.Row> : 
        tabKey === 2 ? <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading || item.disabled}
        >
            <IndexTable.Cell>
                <div className='table_text_20' onClick={stopActionDeep}><Button variant='plain' textAlign="left" onClick={() => {
                    window.open(`https://${domain}${item.fr_link}`)
                }}>{item.fr_link}</Button></div>
            </IndexTable.Cell>
            <IndexTable.Cell>{Boolean(item.traffic) ? item.traffic : 0}</IndexTable.Cell>
            <IndexTable.Cell>
                <div onClick={stopActionDeep} className='flex_layout'>
                    <Button 
                        disabled={item.disabled}
                        loading={item.redBtnLoading}
                        onClick={() => updateTableIgnore(item, 'reduction')}
                    >{t("Unignore")}</Button>
                    <Button 
                        disabled={item.disabled}
                        loading={item.delBtnLoading}
                        onClick={() => deleteBrokenLink(item)}
                    >{t("Delete")}</Button>
                </div>
            </IndexTable.Cell>
        </IndexTable.Row> : null
    });

    useEffect(() => {
        getTableItemState([selectedResources, allResourcesSelected]); // 表格选择状态

    }, [selectedResources, allResourcesSelected]);

    useEffect(() => {
        // 针对切换tab做清除
        return () => {
            clearSelection();
        }
    }, [tabKey, dataList])

    return (
        <div className='index_table_box'>
            <IndexTable
                resourceName={resourceName}
                itemCount={dataList.length}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                hasMoreItems
                // hasZebraStriping
                promotedBulkActions={promotedBulkActions}
                headings={headings}
                selectable={(!checkState && tabKey === 0) || tabKey !== 0}
            >
                {TableDataList}
            </IndexTable>
        </div>
    )
};


export default IndexTableBox;